import React from "react";

const AppScreen = (props) => {
  return (
    <section
      className="min-h-screen overflow-x-hidden bg-gradient-to-br from-indigo-500 to-red-400  sm:from-indigo-600 sm:to-red-500 relative"
      children={props.children}
    ></section>
  );
};

export default AppScreen;
